enum ChainIds {
	MAINNET = 1,
}

export default ChainIds;
